import { render, staticRenderFns } from "./resumeManagement.vue?vue&type=template&id=8faa1e34&scoped=true&"
import script from "./resumeManagement.vue?vue&type=script&lang=js&"
export * from "./resumeManagement.vue?vue&type=script&lang=js&"
import style0 from "./resumeManagement.vue?vue&type=style&index=0&id=8faa1e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa1e34",
  null
  
)

export default component.exports